<div class="queue-container">
  <app-header-actions [headerTitle]="'SECTION.QUEUE' | translate" [headerIcon]="faClock" [config]="queueHeaderConfig"
    [count]="tasks.length + ' ' + ('SECTION.TASKS.LIST' | translate)" [showCount]="true" (backClick)="goBack()"
    (help)="openHelpModal()"></app-header-actions>

  <div class="queue-stats-section">
    <h3>{{ 'SECTION.QUEUE.STATISTICS' | translate }}</h3>
    @if (stats) {
    <div class="stats-cards">
      <div class="stat-card queued-card">
        <fa-icon [icon]="faClock" class="stat-icon"></fa-icon>
        <div class="stat-content">
          <span class="stat-value">{{ stats.queued }}</span>
          <span class="stat-label">{{ 'QUEUE.STATUS.QUEUED' | translate }}</span>
        </div>
      </div>
      <div class="stat-card running-card">
        <fa-icon [icon]="faSpinner" class="stat-icon"></fa-icon>
        <div class="stat-content">
          <span class="stat-value">{{ stats.running }}</span>
          <span class="stat-label">{{ 'QUEUE.STATUS.RUNNING' | translate }}</span>
        </div>
      </div>
      <div class="stat-card completed-card">
        <fa-icon [icon]="faCheck" class="stat-icon"></fa-icon>
        <div class="stat-content">
          <span class="stat-value">{{ stats.completed }}</span>
          <span class="stat-label">{{ 'QUEUE.STATUS.COMPLETED' | translate }}</span>
        </div>
      </div>
      <div class="stat-card failed-card">
        <fa-icon [icon]="faTimes" class="stat-icon"></fa-icon>
        <div class="stat-content">
          <span class="stat-value">{{ stats.failed }}</span>
          <span class="stat-label">{{ 'QUEUE.STATUS.FAILED' | translate }}</span>
        </div>
      </div>
      <div class="stat-card cancelled-card">
        <fa-icon [icon]="faBan" class="stat-icon"></fa-icon>
        <div class="stat-content">
          <span class="stat-value">{{ stats.cancelled }}</span>
          <span class="stat-label">{{ 'QUEUE.STATUS.CANCELLED' | translate }}</span>
        </div>
      </div>
    </div>
    }
  </div>

  <div class="tasks-section">
    <div class="tasks-header">
      <div class="header-left">
        <h3>{{ 'SECTION.TASKS.LIST' | translate }}</h3>
        <div class="search-container">
          <input type="text" [placeholder]="'SEARCH.PLACEHOLDER.QUEUE' | translate" (input)="onSearch($event)" [value]="searchTerm">
        </div>
      </div>
      <div class="tasks-actions">
        <button class="clear-old-btn" (click)="clearOldJobs()" [title]="'BUTTON.CLEAR' | translate">
          <fa-icon [icon]="faTrashAlt"></fa-icon>
          <span>{{ 'BUTTON.CLEAR' | translate }}</span>
        </button>
        <button class="refresh-btn" (click)="refreshData()" [title]="'BUTTON.REFRESH.TITLE' | translate">
          <fa-icon [icon]="faSync"></fa-icon>
        </button>
      </div>
    </div>

    <div class="tasks-list">
      <app-item-list [items]="listItems" [loading]="loading" [config]="listConfig" (actionClick)="onActionClick($event)"></app-item-list>

      <app-pagination [currentPage]="currentPage" [pageSize]="pageSize" [totalItems]="totalItems"
        [totalPages]="Math.ceil(totalItems / pageSize)" (pageChange)="onPageChange($event)"></app-pagination>

      @if (totalItems === 0 && !loading) {
      <div class="empty-message">
        <fa-icon [icon]="faExclamationCircle" class="empty-icon"></fa-icon>
        <span>{{ 'MESSAGE.NO.TASKS' | translate }}</span>
      </div>
      }
    </div>
  </div>
</div>

@if (selectedTask) {
  <app-modal-task-details [task]="selectedTask" (close)="closeModal()"></app-modal-task-details>
}